import { z } from 'zod';
import type {
  GetInboundReceiptRequest,
  GetInboundReceiptResponse,
} from './get-inbound-receipt.dto.js';
import { InboundReceiptDetailDtoSchema } from './inbound-receipts-shared.schema.js';

export const GetInboundReceiptRequestSchema: z.ZodType<GetInboundReceiptRequest> = z
  .object({
    companyId: z.uuid(),
    receiptId: z.uuid(),
  })
  .strict();

export const GetInboundReceiptResponseSchema: z.ZodType<GetInboundReceiptResponse> = z
  .object({
    receipt: InboundReceiptDetailDtoSchema,
  })
  .strict();
